import { Gettable, Settable } from './configAttributeInterfaces';

export class SimpleConfigValue<T1, T2> implements Gettable<T1, T2>, Settable<T1, T2> {
  constructor(
    protected _context: T1,
    protected _default: null | T2 = null,
    protected _value: null | T2 = null,
  ) {
    this.set(_value);
  }

  public context(): T1 {
    return this._context;
  }

  public get(): null | T2 {
    return this._value;
  }

  public set(value: null | T2 = null): T1 {
    this._value = (value == null) ? this._default : value;
    return this._context;
  }
}
